import React from 'react';
import AdSenseAd from './AdSenseAd';
import { ProductionOnly } from '../../hooks/useProduction';
import { ADSENSE_CONFIG } from '../../config/adsense';

// Componente para anuncio en el home
export const HomeAd = () => (
    <ProductionOnly
        fallback={
            <div style={{
                padding: '2rem',
                margin: '2rem 0',
                border: '2px dashed #ccc',
                textAlign: 'center',
                color: '#666',
                fontSize: '14px'
            }}>
                [Espacio para anuncio HOME - Solo visible en producción]
            </div>
        }
    >
        <AdSenseAd 
            adSlot={ADSENSE_CONFIG.adSlots.homeBanner}
            adFormat="auto"
            height="250px"
            mobileHeight="200px"
        />
    </ProductionOnly>
);

// Componente para anuncio en artículos
export const ArticleAd = () => (
    <ProductionOnly
        fallback={
            <div style={{
                padding: '1.5rem',
                margin: '1.5rem 0',
                border: '2px dashed #ccc',
                textAlign: 'center',
                color: '#666',
                fontSize: '12px'
            }}>
                [Anuncio IN-ARTICLE - Solo visible en producción]
            </div>
        }
    >
        <AdSenseAd 
            adSlot={ADSENSE_CONFIG.adSlots.inArticle}
            adFormat="fluid"
            adLayout="in-article"
            height="200px"
            mobileHeight="150px"
            style={{ textAlign: 'center' }}
        />
    </ProductionOnly>
);

// Componente para anuncio al final de artículos
export const ArticleEndAd = () => (
    <ProductionOnly
        fallback={
            <div style={{
                padding: '2rem',
                margin: '2rem 0',
                border: '2px dashed #ccc',
                textAlign: 'center',
                color: '#666',
                fontSize: '14px'
            }}>
                [Anuncio final de artículo - Solo visible en producción]
            </div>
        }
    >
        <AdSenseAd 
            adSlot={ADSENSE_CONFIG.adSlots.articleEnd}
            adFormat="auto"
            height="300px"
            mobileHeight="250px"
        />
    </ProductionOnly>
);

// Componente para anuncio en About
export const AboutAd = () => (
    <ProductionOnly
        fallback={
            <div style={{
                padding: '1.5rem',
                margin: '1.5rem 0',
                border: '2px dashed #ccc',
                textAlign: 'center',
                color: '#666',
                fontSize: '12px'
            }}>
                [Anuncio en About - Solo visible en producción]
            </div>
        }
    >
        <AdSenseAd 
            adSlot={ADSENSE_CONFIG.adSlots.aboutPage}
            adFormat="auto"
            height="200px"
            mobileHeight="150px"
        />
    </ProductionOnly>
);